<template>
  <div class="week_view">
    <div class="date_title">
      <div class="blank_space"></div>
      <div class="date_title_items">
        <div class="title_item" v-for="(item,index) in weekDateNameList">
          {{ item }} {{ weekDateList[index] | clearYear }}
          <span class="today" v-if="getZeroTime(weekDateList[index]) === getZeroTime()">今</span>
        </div>
      </div>
    </div>
    <div class="date_body">
      <div class="scroll_content_week">
        <div class="scroll_content_week_box">
          <div class="date_body_scale">
            <div class="scale_item" v-for="(item,index) in 24">
              {{ item | formatScale}}
            </div>
          </div>
          <div class="date_body_content">
            <div class="day_list" v-for="(item,index) in weekDateList">
              <div class="hours_list" v-for="(itemHours,indexH) in 24">
                <TaskDefaultPop v-if="formatTaskList[item + ':' + (indexH<10?'0'+indexH:indexH)] != undefined" :taskList="formatTaskList[item + ':' + (indexH<10?'0'+indexH:indexH)]" :invoke="invoke"></TaskDefaultPop>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {utils} from '../common/common'
import TaskDefaultPop from './TaskDefaultPop.vue'

export default {
  components:{
    TaskDefaultPop
  },
  props: {
    dateValue: String,
    invoke:Function,
    weekData:Array,
    currentDateType:String
  },
  watch: {
    dateValue: function (val) {
      this.weekDateList = utils.getWeek(val)
      if(utils.getYearWeek(val) !== this.curWeekId && this.currentDateType === 'week'){
       this.getWeekData(val);
      }
    },
    currentDateType:function (val){
      if(val === 'week'){
        this.getWeekData(this.dateValue);
      }
    },
    weekData(val){
      this.formatTaskList = this.formatTask(val)
    }
  },
  filters: {
    clearYear(time) {
      if (time != undefined || time != null) {
        return String(time).substring(5);
      } else {
        return ''
      }
    },
    formatScale(num){
      num = num-1;
      if(num<10){
        num = "0" + num;
      }
      return num + ":00";

    }
  },
  data() {
    return {
      weekDateNameList: ["星期一", "星期二", "星期三", "星期四", "星期五", "星期六", "星期日"],
      weekDateList: [],
      formatTaskList: [],
      curWeekId:''
    }
  },
  mounted() {
    //赋值周一到周日的多语言文字
    this.weekDateNameList = [this.getLangMsg("intvTaskCale_mon"),
      this.getLangMsg("intvTaskCale_tues"),
      this.getLangMsg("intvTaskCale_wednes"),
      this.getLangMsg("intvTaskCale_thurs"),
      this.getLangMsg("intvTaskCale_fri"),
      this.getLangMsg("intvTaskCale_satur"),
      this.getLangMsg("intvTaskCale_weekd")]
    //去除滚动条
    this.$nextTick(()=>{
      this.clearScroll();
      this.initTimePosition();
    })
  },
  methods: {
    clearScroll() {
      let scrollWidth = $(".week_view .scroll_content_week")[0].offsetWidth - $(".week_view .scroll_content_week")[0].clientWidth;
      $(".week_view .scroll_content_week").css("marginRight", "-" + scrollWidth + "px")
    },
    formatTask(list) {
      let newTaskObj = {};
      for (let i = 0; i < list.length; i++) {
        if (list[i].startTimeLong == "" || list[i].startTimeLong == null || list[i].startTimeLong == undefined) {
          continue;
        }
        let timeStr = utils.dateFormat("yyyy/MM/dd:hh",list[i].startTimeLong);
        if (!newTaskObj[timeStr]) {
          newTaskObj[timeStr] = [];
        }
        newTaskObj[timeStr].push(list[i])
      }
      return newTaskObj;
    },
    initTimePosition(){
       let curHourse = new Date().getHours();
       if(curHourse<13){
         $(".week_view .scroll_content_week").animate({ scrollTop: "335px" }, 500);
       }else{
         $(".week_view .scroll_content_week").animate({ scrollTop: "505px" }, 500);
       }
    },
    getWeekData(val){
      console.log('获取周数据')
      let timeRange = {
        startTime:this.getZeroTime(this.weekDateList[0]),
        endTime:this.getZeroTime(utils.getNextDate(this.weekDateList[6],1))
      }
      console.log(new Date(timeRange.startTime),new Date(timeRange.endTime))
      this.invoke("getWeekData",timeRange);
      this.curWeekId = utils.getYearWeek(val)
    },
  }
}
</script>
<style lang="less">
.week_view {
  color: #333333;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100px;

  .date_title {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    height: 42px;
    flex-shrink: 0;

    .blank_space {
      width: 55px;
    }

    .date_title_items {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      flex-shrink: 1;
      align-items: stretch;
      background: #F6F6F8;
      border: 1px solid #E5E5E5;

      .title_item {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        flex-shrink: 1;
        color: #333333;
        .today{
          width: 18px;
          height: 18px;
          line-height: 18px;
          text-align: center;
          flex-shrink: 0;
          margin-left: 3px;
          border-radius: 50%;
          background: #5582F3;
          background: var(--theme-color);
          color: #FFFFFF;
          transform: scale(0.833);
        }
      }
    }

  }

  .date_body {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 1;
    height: 100px;
    overflow-x: hidden;

    .scroll_content_week {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      flex-grow: 1;
      flex-shrink: 1;
      overflow-y: scroll;
      .scroll_content_week_box{
        display: flex;
        flex-direction: row;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }

    .date_body_scale {
      width: 55px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: stretch;

      .scale_item {
        flex-shrink: 0;
        height: 42px;
        text-align: center;
      }
    }

    .date_body_content {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      flex-shrink: 1;
      border-left: 1px solid #E5E5E5;

      .day_list {
        width: 100px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;

        .hours_list {
          display: flex;
          flex-direction: row;
          align-items: stretch;
          flex-shrink: 0;
          height: 42px;
          border-bottom: 1px solid #E5E5E5;
          border-right: 1px solid #E5E5E5;
          //&:hover{
          //  background: #EDF2FF;
          //}

        }
      }
    }
  }
}

</style>